<div
  class="button-card"
  [class.warning]="cardStyle() === 'warning'"
  [class.negative]="cardStyle() === 'negative'"
>
  <div class="header">
    <div class="card-title">{{ title() }}</div>
    <div class="body1">{{ bodyLine1() }}</div>
    @if (bodyLine2()) {
      <div class="body1">{{ bodyLine2() }}</div>
    }
  </div>
  <div class="button--container">
    @if (controlType() === 'toggle') {
      <mat-slide-toggle
        [id]="toggleId()"
        [checked]="toggleValue()"
        [disabled]="isDisabled()"
        color="primary"
        (change)="toggleChanged.emit($event.checked)"
      ></mat-slide-toggle>
    } @else {
      <app-icon-button
        [label]="buttonLabel()"
        [buttonId]="buttonId()"
        [buttonStyle]="iconButtonStyle()"
        [iconName]="iconName()"
        buttonShape="square"
        [isDisabled]="isDisabled()"
        (buttonClicked)="buttonClicked.emit()"
      ></app-icon-button>
    }
  </div>
</div>
